//Componentes generales
import React, { useState, useContext, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import Routes_gral from '../../utils/Routes_gral';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


//Estilos
import './Login.css';

//Imagenes
import logoXertux from '../../images/MANTENIMIENTO.png'
import logoG4 from '../../images/LOGO-BLANCOV1.png'

//Contexto
import authContext from '../../context/authentication/authContex';

// Alertas
import Swal from 'sweetalert2'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

/* 
    Vista donde se gestiona toda la lógica de inicio de sesión en la aplicación.
        Donde props no se encuentra en uso.
*/
function Login(props) {

    //Context de Autenticacion   
    const aContext = useContext(authContext);
    const { usuario, mensaje, token, autenticado, iniciarSesion, usuarioAutenticado, verificarLicencia, cerrarSesion, checkIfMachinistic, checkIfSupervisor } = aContext;
    const [loading,setLoading] = useState(false);

    const [showPassword,setShowPassword] = useState(false);

    //Inicializo navegacion
    const navigate = useNavigate();

    // const isClub = true;
    const isClub = window.location.hostname == 'cnmp.xertux.com'
    const isCasport = window.location.hostname == 'mantenimiento.casport.com.ar'
    const isMoviport = window.location.hostname == 'mantenimiento.moviportsa.com.ar'

    //State
    const [usuarioState, setUsuarioState] = useState({ userName: "", password: "", tenantId: isClub ? 'CNMP' : isCasport ? 'CASPORT' : isMoviport ? 'MOVIPORT' : "" });

    /*
        Función que muestra una alerta popIt del mensaje seteado en el contexto. 
    */
    const alerta = () => {
        if(mensaje != null && mensaje != ''){
            if(mensaje.includes('contraseña')){
                Swal.fire({
                title:'Contraseña',
                text:mensaje,
                icon:'warning',
                confirmButtonText:'Cambiarla Ahora',
                showCancelButton:true,
                cancelButtonText:'Entendido'
                }).then(e => {
                    if(e.isConfirmed){
                        navigate(Routes_gral.newPassword, {state:{user:usuario}});
                    }
                })
            }else Swal.fire({
                text: mensaje,
                icon: 'warning',
                confirmButtonText: 'OK'
            })
        }
    }

    /* 
        Disparador que se ejecuta ante cambios en la variable mensaje proveniente del context. El mismo llama a la función de alerta.
    */
    useEffect(() => {
        if(mensaje != null)
            alerta();
    }, [mensaje]);
    

    /* 
        Función que controla el evento de Inicio de Sesión (Botón). En el mismo se verifica la licencia e intenta iniciar sesión.
    */
    const onSubmit = async () => {
        if (!usuarioState.userName || !usuarioState.password || !usuarioState.tenantId) return;
        setLoading(true);
        try {
            const resp = await iniciarSesion(usuarioState);

            if (!resp.autenticado) throw Error(resp.error.response.data.message);

            let respLicense = await verificarLicencia();
            
            if(respLicense.vencida != undefined && respLicense.vencida){
                await cerrarSesion(false);
                throw new Error('LICENCIA DE USO VENCIDA. Comuníquese con el Administrador.');
            }
            await usuarioAutenticado();
            setLoading(false); 
        } catch (error) {
            console.log('ERROR EN INICIAR SESION');
            console.log(error);

            if (error.response?.status === 429) {
                Swal.fire({
                    title: 'Limite alcanzado',
                    text: error.response.data?.message || 'Limite de usuarios intentando ingresar alcanzado, intente nuevamente en un minuto o comuniquese con soporte',
                    icon: 'warning'
                })
            } else {
                Swal.fire({
                    title: error.message,
                    text: (error.message.includes('LICENCIA DE USO') || error.message.includes('El Servidor no se encuentra') || error.message.includes('NO habilitado')) ? undefined : 'Revise sus credenciales de autenticacion',
                    icon:'error'
                })
            }
            setLoading(false);
        }
    }

    /* 
        Manejador que setea el usuario por el ingresado.
            Donde userText es el texto ingresado.
    */
    const handlerInputUser = userText => setUsuarioState({ ...usuarioState, 'userName': userText.target.value });

    /* 
        Manejador que setea la contraseña por la ingresado.
            Donde passText es el texto ingresado.
    */
    const handlerInputPass = passText => { setUsuarioState({ ...usuarioState, 'password': passText.target.value });}
    
    /* 
        Manejador que setea la contraseña por la ingresado.
            Donde passText es el texto ingresado.
    */
    const handlerInputTenantId = tenantText => { setUsuarioState({ ...usuarioState, 'tenantId': tenantText.target.value });}

    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(()=>{
        function handleResize() {
            setWindowSize({
              width: window.innerWidth,
              height: window.innerHeight,
            });
          }
        window.addEventListener('resize',handleResize);
        return () => window.removeEventListener('resize',handleResize);
    },[windowSize])

    return (
        <div className='container-login'>
            <div className="card-login">
                <div className={`${isClub ? 'twoImages' : ''} containerImg`}>
                    <img className='imgMain' src={isClub ? './nuevoLogoXertux.png' : logoXertux} alt='Logo-Principal' />
                </div>
                <div className='containerForm'>
                    <div className="submitOptionsContainerStyle">
                        {
                            !isClub && <div className="divNavLinkSignUp">
                                <label style={{color:'black'}}>¿No tienes una cuenta?</label>
                                <NavLink onClick={() => aContext.limpiarError()} to={Routes_gral.signup} className="navLinkSignUp">
                                    Regístrate
                                </NavLink>
                            </div>
                        }
                        {
                            !isClub && <NavLink className="navLinkRecoverPassword" onClick={() => aContext.limpiarError()} to={Routes_gral.recoverPassword}>
                                ¿Has olvidado la contraseña?
                            </NavLink>
                        }
                        
                    </div>
                    
                    {isClub && <img className='secondaryImg' src={'./cnmpsinfondoCortado.png'} alt='Logo-Principal' />}

                    <div className='inputsContainer'>

                        <div className="containerInput">
                            <input className="textInput" id="username" placeholder="Username" type="text" name="username" onChange={handlerInputUser} />
                        </div>
                        <div className="containerInput containerInputPassword">
                            
                            <input className="textInput" id="password" placeholder="Password" type={showPassword ? 'text' : 'password'} name="user_password" onChange={handlerInputPass} onKeyDown={(keyName) => keyName.key === 'Enter' ? onSubmit() : null } ></input>
                            <FontAwesomeIcon className='showPasswordBtn' icon={showPassword ? faEyeSlash : faEye} onClick={()=>setShowPassword(!showPassword)}/>
                        </div>
                        <div className="containerInput">
                            <input className="textInput" id="tenantId" placeholder="Alias de Empresa" type="text" name="user_password" onChange={handlerInputTenantId} disabled={isClub || isCasport || isMoviport} value={usuarioState.tenantId} onKeyDown={(keyName) => keyName.key === 'Enter' ? onSubmit() : null } />
                        </div>                        
                    </div>

                    <div className="submitOptionsContainerStyle">
                        <button id="myBtn" className={`btnSubmitLoginStyle ${usuarioState.userName == "" || usuarioState.password == "" || usuarioState.tenantId == "" ? 'disabled' : ''}`} disabled={usuarioState.userName == "" || usuarioState.password == "" || usuarioState.tenantId == ""} onClick={onSubmit}>{loading ? <h4 className='warningStatusMsg'><span>.</span><span>.</span><span>.</span></h4> : 'Ingresar'}</button>
                        {
                            isClub ? 
                            <NavLink className="navLinkRecoverPassword secondBtn" onClick={() => Swal.fire({title:'Ops!', text:'Por política del CNMP debes comunicarte con el Administrador para actualizarla', icon:'warning'})}>
                                ¿Has olvidado la contraseña?
                            </NavLink>
                            :
                            <NavLink className="navLinkRecoverPassword secondBtn" onClick={() => aContext.limpiarError()} to={Routes_gral.recoverPassword}>
                                ¿Has olvidado la contraseña?
                            </NavLink>
                        }
                        {
                            !isClub && <div className="divNavLinkSignUp">
                                <label style={{color:'black'}}>¿No tienes una cuenta?</label>
                                <NavLink onClick={() => aContext.limpiarError()} to={Routes_gral.signup} className="navLinkSignUp">
                                    Regístrate
                                </NavLink>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login